__turbopack_context__.v({
  "backButton": "lh7d3G_backButton",
  "rightNavGroup": "lh7d3G_rightNavGroup",
  "workNavBar": "lh7d3G_workNavBar",
});
